<template>
  <div class="page">
    <div class="tips">{{ $t('请输入您用于注册媒体记者的身份证件号') }}</div>
    <div class="main">
      <div class="input">
        <input v-model="idNo" :placeholder="$t('请填写')" />
      </div>
      <p>
        {{
          $t(
            '媒体记者注册后，需等待终审通过才能访问新闻中心媒体板块。请在PC端登录媒体注册系统，进行注册或查询审核状态。'
          )
        }}
      </p>
      <div class="btn" @click="check">{{ $t('立即验证') }}</div>
    </div>
  </div>
</template>

<script>
import { setToken } from '@/utils/auth'
import getTranslation from '@/locale/getTranslation'
import { mediaLoginApi } from '@/api/news'
export default {
  data() {
    return {
      idNo: ''
    }
  },
  methods: {
    async check() {
      try {
        const {
          accessToken = '',
          refreshToken = '',
          user = '',
          account = ''
        } = await mediaLoginApi({
          idNo: this.idNo
        })
        setToken({ accessToken, refreshToken, user, account })
        try {
          window.bridge.onRefreshMediaToken(
            JSON.stringify({
              userName: user,
              accountName: account,
              refreshToken,
              token: accessToken
            })
          )
        } catch (error) {
          console.log('APP注入cookie失败')
        }

        // 判断URL中是否有returnUrl参数，如果有则跳转到该地址，否则跳转到新闻中心
        const returnUrl = decodeURIComponent(this.$route.query.returnUrl)
        if (returnUrl) {
          window.location.href = returnUrl
          return
        }

        this.$notify({
          type: 'success',
          message: getTranslation('验证成功，正在跳转新闻中心！'),
          duration: 2000
        })
        this.$router.push('/mobile/news')
      } catch (error) {
        if (error.status === 400) {
          this.$router.push('/mobile/login/error')
        } else {
          console.log(error)
          this.$toast(error.data.message)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .tips {
    background: #fdfcec;
    text-align: center;
    height: 0.64rem;
    line-height: 0.64rem;
    color: #f86e21;
    font-size: 0.24rem;
  }
  .main {
    flex: 1;
    -webkit-flex: 1;
    margin: 0.3rem;
    background: #fff;
    border-radius: 0.2rem;
    font-size: 0.28rem;
    color: #999;
    padding: 0.3rem;
    .input {
      height: 1rem;
      line-height: 1rem;
      border-bottom: 1px solid #e6e9ee;
      > input {
        height: 0.6rem;
        width: 100%;
        margin: 0.2rem auto;
        font-size: 0.3rem;
        line-height: 100%;
        color: #333;
      }
    }
    > p {
      line-height: 0.34rem;
      padding: 0.35rem 0;
    }
    .btn {
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      color: #fff;
      font-size: 0.32rem;
      border-radius: 0.4rem;
      @include linearBg();
    }
  }
}
</style>
